import React from "react";

const Java_ShortHand_IfElse = () => {
  return (
    <div>
      <h1>Java ShortHand IfElse</h1>
      <p>This page provides explanations, examples, and common use-cases for Java ShortHand IfElse in Java.</p>
    </div>
  );
};

export default Java_ShortHand_IfElse;
